import styled from '@emotion/styled';
import React from 'react';
import { TestId } from '@components/test-ids';
import { withTheme } from '@emotion/react';
import { Theme } from '@theme/base';
import { Grid } from '@mui/material';
import { SectionTitle, SectionTitleSizes } from '../section-title';
import { OfferTileContainer } from './OfferTileContainer';
import { OfferType, OffersResponse } from '@model/offers/offers';

/* ***************** *
 *       Types       *
 * ***************** */
export interface OffersGroupProps {
  testId?: string;
  theme?: Theme;
  offerTypesResponse: OffersResponse<OfferType>;
  className?: string;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div({});

/* ***************** *
 *    OffersGroup    *
 * ***************** */

export const OffersGroupComponent = ({ offerTypesResponse, theme, testId, className }: OffersGroupProps) => {
  if (!offerTypesResponse) {
    return null;
  }

  const { data: offerTypes } = offerTypesResponse;

  if (!offerTypes || !offerTypes.length) {
    return null;
  }

  const getGridColumns: any = () => {
    switch (offerTypes.length) {
      case 1:
      case 2:
        return {
          xs: 12,
          sm: 6
        };
      case 3:
        return {
          xs: 12,
          sm: 6,
          md: 4
        };
      default:
        return {
          xs: 12,
          sm: 6,
          md: 3
        };
    }
  };

  const renderOfferTypeTiles = () =>
    offerTypes.map((offerType: OfferType) => (
      <Grid key={offerType} item {...getGridColumns()}>
        <OfferTileContainer offerType={offerType} />
      </Grid>
    ));

  return (
    <Container className={className} data-testid={testId || TestId.dynamicOffersComponent.main}>
      <SectionTitle heading={'common__label--special-offers'} size={SectionTitleSizes.LARGE} />
      <Grid container spacing={theme!.custom.gridSpacing.default}>
        {renderOfferTypeTiles()}
      </Grid>
    </Container>
  );
};

export const OffersGroup = withTheme(OffersGroupComponent);
